import { Fragment } from 'react'
import InnerHTML from "dangerously-set-html-content";
import CopyButton from '../CopyButton';

const LimitReached = ({ onClose, freeMessage, appId }) => {
  return (
    <Fragment>
      <div className='p-4 overflow-y-auto'>
        <div className="text-right -mt-2.5">
          <button onClick={onClose}>X</button>
        </div>
        <div className='flex flex-col gap-4'>
          {freeMessage ?
            <InnerHTML
              html={freeMessage}
              className={freeMessage ? "inner-html text-black text-lg text-justify w-full mx-auto pt-8 mb-6 ttci-break-word whitespace-pre-wrap": ''}
            /> :
            null
          }

          <div className='flex flex-col'>
            <span>Copy the Account ID below as you will need it when you check-out!</span>
            <CopyButton text={appId} />
          </div>
        </div>
      </div>
    </Fragment>  
  )
}

export default LimitReached
